module.exports = __webpack_public_path__ + "static/media/TelaRayasPcMin.f21dfda0.jpg";